export default __webpack_public_path__ + "static/media/financeReports.7b4e1820.svg";